export default __webpack_public_path__ + "static/media/na-photo.3cda3839.jpg";